import { useLayoutEffect, useRef } from "preact/hooks";
import { attachBoard, detachBoard } from "../../legacy/board.js";

/**
 * The host Chessground draws into.
 *
 * Two rules keep an imperative widget and a virtual DOM from fighting over the same nodes:
 *
 *  - The element has no children in the JSX. Preact therefore never diffs inside it, and everything
 *    below belongs to Chessground.
 *  - It mounts once. The effect has no dependencies, so it never re-runs; and nothing above may give
 *    this component a `key` or wrap it in a condition, or Preact would unmount it and the board
 *    would reset in the middle of a practice. The end-to-end walk asserts the node survives ten moves.
 *
 * The effect is a layout effect on purpose: it runs before render() returns, so the rest of the boot
 * finds the board already there.
 */
export function Board() {
    const host = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        attachBoard(host.current!);
        return () => detachBoard();
    }, []);

    return <div id="board" class="board" ref={host} />;
}
